/**
 * User status (uStatus 0-9) — the integer status flag the legacy
 * `user_status` cmd carried. The AS source treats it as opaque; labels
 * were SWF-side. We define a faithful 10-slot enum matching typical
 * FFR-chat usage (Online / AFK / Busy / In MP / etc.) and a coloured
 * dot mapping.
 *
 * The 10 slots match the legacy ComboBox length and keep value 0 as
 * the implicit "default/online" state (which is what the AS does in
 * line 272: `u.properties.put("uStatus", 1)` for an initial join — we
 * keep that semantic).
 */

export interface StatusOption {
    label: string;
    /** CSS colour for the indicator dot. */
    color: string;
}

export const STATUS_OPTIONS: StatusOption[] = [
    { label: 'Online',       color: '#13CC23' },  // 0 default
    { label: 'AFK',          color: '#F7E138' },  // 1 (used by AS on join)
    { label: 'Busy',         color: '#c91e1e' },  // 2
    { label: 'In Multiplayer',color: '#0062ca' }, // 3
    { label: 'Practicing',   color: '#8e2dff' },  // 4
    { label: 'Recording',    color: '#FF6618' },  // 5
    { label: 'Watching',     color: '#00d4ff' },  // 6
    { label: 'Asleep',       color: '#888888' },  // 7
    { label: 'Playing',      color: '#ff66cc' },  // 8
    { label: 'Idle',         color: '#aab5c8' },  // 9
];

export function statusLabel(s: number | undefined): string {
    return STATUS_OPTIONS[s ?? 0]?.label ?? 'Online';
}

export function statusColor(s: number | undefined): string {
    return STATUS_OPTIONS[s ?? 0]?.color ?? STATUS_OPTIONS[0]!.color;
}
